import React from 'react';
import { SvgIcon } from "@material-ui/core";

export const CheckIcon = (props: any) => {
  return (
    <SvgIcon {...props} width="12" height="10" viewBox="0 0 12 10">
      <path fill="currentColor" fillRule="nonzero" d="M10.312.019L4.197 6.194 1.679 3.676 0 5.355 4.197 9.61l7.794-7.854z"/>
    </SvgIcon>
  );
};